export const WORDS = [
  'ander',
  'annie',
  'bella',
  'britt',
  'chris',
  'holly',
  'kiera',
  'marie',
  'mutti',
]
